// --- 部门管理 --- //

export default [
  {
    name: 'departmentType',
    path: '/platformManagement/departmentManagement/departmentType',
    meta: { title: '部门类型' },
    component: require('business/platformManagement/departmentManagement/departmentType/list.vue').default
  },
  {
    name: 'departmentList',
    path: '/platformManagement/departmentManagement/departmentList',
    meta: { title: '部门列表' },
    component: require('business/platformManagement/departmentManagement/departmentList/list.vue').default
  }
]
